<template>
	<div class="work-group-detail">
		<div class="view-title">
			<span v-if="workgroup && workgroup.project_name">{{ workgroup.project_name }}</span>
		</div>
		<div class="view-content">
			<div class="csos-tabs">
				<el-tabs type="card" :active-name="activeTabName" @tab-click="onClickTab">
					<div class="panel">
						<div class="panel-header">
							<div class="clearfix panel-search">
								<div class="dropdown">
									<el-select :placeholder="attrText.select" v-model="searchForm.type">
										<el-option :label="attrText.name" value="q_name"></el-option>
										<el-option label="IP" value="q_ip"></el-option>
									</el-select>
								</div>
								<!--<div class="search">-->
								<el-input icon="search" class="search-input" v-model="searchForm.key" :disabled="!searchForm.type" @keyup.enter.native="onSearch" :on-icon-click="onSearch"> </el-input>
								<!--<a class="btn" @click.stop="onSearch">-->
								<!--<i class="fa fa-search" aria-hidden="true"></i>-->
								<!--</a>-->
								<!--<el-input v-model="searchForm.key" :disabled="!searchForm.type"></el-input>-->
								<!--</div>-->
							</div>
							<!--<div>-->
							<a v-if="activeTabName == 'ecs'" @click="exportAnsible" :href="downloadUrl">
								<i class="fa fa-external-link" aria-hidden="true"></i>
								<translate>Export Ansible</translate>
							</a>
							<!--</div>-->
						</div>
					</div>
					<!--主机tab-->
					<el-tab-pane :label="attrText.instance" name="ecs">
						<div>
							<el-table v-loading="loading" :data="instances" v-if="instances !== ''" style="width: 100%">
								<el-table-column :label="attrText.name">
									<template scope="scope">
										<!--<el-tooltip class="item" effect="dark" :content="scope.row.resource.name" placement="top">-->
										<span>{{ scope.row.name }}</span>
										<!--</el-tooltip>-->
									</template>
								</el-table-column>
								<el-table-column label=" " width="30">
									<template scope="scope">
										<el-tooltip class="item" effect="dark" :content="scope.row.type === 'LinuxServer' ? 'Linux' : 'Windows'" placement="top">
											<img :src="`../../../static/images/${scope.row.type === 'LinuxServer' ? 'linux' : 'win32'}.png`" alt="" />
										</el-tooltip>
									</template>
								</el-table-column>
								<el-table-column prop="ip" label="IP"> </el-table-column>
								<el-table-column :label="attrText.cluster">
									<template scope="scope">
										<el-tooltip class="item" effect="dark" :content="attrText.available" placement="top" v-if="scope.row.agent_status === 1 && scope.row.network_name">
											<span class="tip-point available"></span>
										</el-tooltip>
										<el-tooltip class="item" effect="dark" :content="attrText.unavailable" placement="top" v-if="scope.row.agent_status !== 1 && scope.row.network_name">
											<span class="tip-point unavailable"></span>
										</el-tooltip>
										<span>{{ scope.row.network_name }}</span>
									</template>
								</el-table-column>
								<el-table-column :label="attrText.avaliableCode">
									<template scope="scope">
										<!-- <span v-if="tunnelCode && tunnelCode[scope.row.id] && tunnelCode[scope.row.id][0]">{{tunnelCode[scope.row.id][0].code}}</span> -->
										<span>{{ hideStr(scope.row.code) }}</span>
									</template>
								</el-table-column>
								<el-table-column width="100" :label="attrText.onlineSession">
									<template scope="scope">
										<el-button type="text" @click.stop="onShowConnections(scope.row)" :disabled="scope.row.online_connections < 1">
											{{ scope.row.online_connections }}
										</el-button>
									</template>
								</el-table-column>
								<el-table-column width="100" :label="attrText.connectLog">
									<template scope="scope">
										<el-button type="text" @click.stop="onShowConnectionLogs(scope.row)" :disabled="scope.row.logs < 1">
											{{ scope.row.logs }}
										</el-button>
									</template>
								</el-table-column>
								<el-table-column width="360" :label="attrText.action">
									<template scope="scope">
										<el-button type="text" :disabled="scope.row.agent_status !== 1" @click.stop="onShowConnect(scope.row)">
											<translate>Connect</translate>
										</el-button>
										<el-button type="text" @click="linuxConfig(scope.row)" :disabled="scope.row.agent_status !== 1">
											<translate>Config</translate>
										</el-button>
										<el-button type="text" @click="manageCode(scope.row)" :disabled="scope.row.agent_status !== 1">
											<translate>Manage Code</translate>
										</el-button>
										<!-- 主机发起审批新入口 -->
										<!-- <el-button v-if="scope.row.type === 'LinuxServer' && scope.row.network_safemode && scope.row.safe_mode_approver" type="text" @click="startApply(scope.row, 'ecs')">
											<translate>Start Application</translate>
										</el-button>
										<el-dropdown trigger="click" @command="onSelectAssistance" v-if="scope.row.type === 'LinuxServer' && scope.row.agent_version && scope.row.agent_version >= '3.0.0'">
											<el-button class="el-dropdown-link" type="text" :disabled="scope.row.agent_status !== 1">
												<translate>Assistance</translate>
												<i class="el-icon-caret-bottom el-icon--right"></i>
											</el-button>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item :command="{ key: 'Manual', row: scope.row }">
													<translate>Manual assistance</translate>
												</el-dropdown-item>
												<el-dropdown-item :command="{ key: 'Operation', row: scope.row }">
													<translate>Operation assistant</translate>
												</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown> -->
									</template>
								</el-table-column>
							</el-table>
							<div class="pagination" v-if="instancesList.totalPage > 1">
								<el-pagination layout="prev, pager, next" :page-count="instancesList.totalPage" :page-size="10" :current-page.sync="instancesList.currentPage" @current-change="changeProjectPage"></el-pagination>
							</div>
						</div>
					</el-tab-pane>
					<!--数据库tab-->
					<el-tab-pane :label="attrText.database" name="rds">
						<el-table v-loading="loading" :data="databases" v-if="databases !== ''" style="width: 100%">
							<el-table-column :label="attrText.name">
								<template scope="scope">
									<!--<el-tooltip class="item" effect="dark" :content="scope.row.resource.name" placement="top">-->
									<span>{{ scope.row.name }}</span>
									<!--</el-tooltip>-->
								</template>
							</el-table-column>
							<el-table-column label=" " width="35">
								<template scope="scope">
									<el-tooltip v-if="scope.row.type == 'PostgreSQLDatabase'" class="item" effect="dark" content="PostgreSQL" placement="top">
										<img :src="`../../../static/images/postgresql.png`" width="16" height="16" alt="" />
									</el-tooltip>
									<el-tooltip v-else-if="scope.row.type == 'OracleDatabase'" class="item" effect="dark" content="Oracle" placement="top">
                    <img :src="`../../../static/images/oracle.png`" width="16" height="12" alt="" />
									</el-tooltip>
									<el-tooltip v-else-if="scope.row.type == 'MySQLDatabase'" class="item" effect="dark" content="MySQL" placement="top">
										<img :src="`../../../static/images/mysql.png`" alt=""  width="16" height="16"  />
									</el-tooltip>
                  <el-tooltip v-else class="item" effect="dark" content="SQL Server" placement="top">
                    <img :src="`../../../static/images/mssql.png`" width="16" height="14" alt="" />
                  </el-tooltip>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.dabaseName">
								<template scope="scope">
									<div v-for="(dbName, dbIndex) in scope.row.db_name" :key="dbIndex" class="database-name-item">{{ dbName }}</div>
								</template>
							</el-table-column>
							<el-table-column prop="ip" label="IP"> </el-table-column>
							<el-table-column :label="attrText.cluster">
								<template scope="scope">
									<el-tooltip class="item" effect="dark" :content="attrText.available" placement="top" v-if="scope.row.agent_status === 1 && scope.row.network_name">
										<span class="tip-point available"></span>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" :content="attrText.unavailable" placement="top" v-if="scope.row.agent_status !== 1 && scope.row.network_name">
										<span class="tip-point unavailable"></span>
									</el-tooltip>
									<span>{{ scope.row.network_name }}</span>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.avaliableCode">
								<template scope="scope">
									<!-- <span v-if="tunnelCode && tunnelCode[scope.row.id]&&tunnelCode[scope.row.id][0]">{{tunnelCode[scope.row.id][0].code}}</span> -->
									<span>{{ hideStr(scope.row.code) }}</span>
								</template>
							</el-table-column>
							<el-table-column width="100" :label="attrText.connectLog">
								<template scope="scope">
									<el-button type="text" @click.stop="onShowConnectionLogs(scope.row)" :disabled="scope.row.logs < 1">
										{{ scope.row.logs }}
									</el-button>
								</template>
							</el-table-column>
							<el-table-column width="300" :label="attrText.action">
								<template scope="scope">
									<!-- test old agent -->

									<el-button type="text" :disabled="scope.row.agent_status !== 1" @click.stop="onShowConnect(scope.row)">
										<translate>Connect</translate>
									</el-button>
									<el-button type="text" :disabled="scope.row.agent_status !== 1" @click="manageCode(scope.row)">
										<translate>Manage Code</translate>
									</el-button>
									<el-button type="text" :disabled="scope.row.agent_status !== 1" @click="check(scope.row)">
										<translate>Check</translate>
									</el-button>
									<!-- 数据库发起审批新入口 -->
									<el-button v-if="scope.row.status === 2" type="text" @click="startApply(scope.row, 'rds')">
										<translate>Start Application</translate>
										<!-- <router-link :to="{ name: 'operation.review', query: { id: scope.row.id + '-' + scope.row.project.id, type: 'sql' } }">
											<translate>SQL Application</translate>
										</router-link> -->
									</el-button>

									<!-- new agent old agent limit -->

									<!-- new agent -->
									<!--<el-tooltip class="item" effect="dark" :content="attrText.notSupport" placement="top" v-if="scope.row.network && scope.row.network.agentVersion >= '3.0.0'">-->
									<!--<el-button type="text" class="btn-disabled-tooltip">-->
									<!--<translate>Connect</translate>-->
									<!--</el-button>-->
									<!--</el-tooltip>-->
									<!--<el-tooltip class="item" effect="dark" :content="attrText.notSupport" placement="top" v-if="scope.row.network && scope.row.network.agentVersion >= '3.0.0'">-->
									<!--<el-button type="text" class="btn-disabled-tooltip">-->
									<!--<translate>Manage Code</translate>-->
									<!--</el-button>-->
									<!--</el-tooltip>-->
									<!--<el-tooltip class="item" effect="dark" :content="attrText.notSupport" placement="top" v-if="scope.row.network && scope.row.network.agentVersion >= '3.0.0'">-->
									<!--<el-button type="text" class="btn-disabled-tooltip">-->
									<!--<router-link>-->
									<!--<translate>SQL Application</translate>-->
									<!--</router-link>-->
									<!--</el-button>-->
									<!--</el-tooltip>-->
									<!-- old agent -->
									<!--<el-button type="text"-->
									<!--:disabled="!scope.row.network || !scope.row.network.agent || scope.row.network.agent.status !== 1 || scope.row.network.agentVersion >= '3.0.0'"-->
									<!--@click.stop="onShowConnect(scope.row)"-->
									<!--v-if="scope.row.network && scope.row.network.agentVersion < '3.0.0'">-->
									<!--<translate>Connect</translate>-->
									<!--</el-button>-->
									<!--<el-button type="text"-->
									<!--:disabled="!scope.row.network || !scope.row.network.agent"-->
									<!--@click="manageCode(scope.row)" v-if="scope.row.network && scope.row.network.agentVersion < '3.0.0'">-->
									<!--<translate>Manage Code</translate>-->
									<!--</el-button>-->
									<!--<el-button type="text" v-if="scope.row.network && scope.row.network.agentVersion < '3.0.0'">-->
									<!--<router-link-->
									<!--:to="{name:'operation.review', query:{id: scope.row.id + '-' + scope.row.project.id, type:'sql'}}" :disabled="scope.row.network.agentVersion >= '3.0.0'">-->
									<!--<translate>SQL Application</translate>-->
									<!--</router-link>-->
									<!--</el-button>-->
								</template>
							</el-table-column>
						</el-table>
						<div class="pagination" v-if="databasesList.totalPage > 1">
							<el-pagination layout="prev, pager, next" :page-count="databasesList.totalPage" :page-size="10" :current-page.sync="databasesList.currentPage" @current-change="changeProjectPage"></el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
			<component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel" @reloadTunnelCode="reloadTunnelCode" @reloadOnlineConnects="reloadOnlineConnects" @reloadPojectResource="reloadPojectResource" @onShowModal="onShowModal" @startApplyEvent="startApplyEvent" @onViewLog="handleViewLog" ref="rightPanel"></component>
		</div>
		<!--弹框-->
		<!--创建code-->
		<el-dialog v-if="m" :title="attrText.createCode" :visible.sync="showModal.showCreateModal" custom-class="create-code-dialog">
			<el-form :label-width="formLabelWidth">
				<el-form-item :label="attrText.securityMode" v-if="m && m.safe.network_safe_mode && m.resource.resource_type === 'ecs' && m.extension.os === 'linux'">
					<el-col :span="6" v-show="!m.safe.safe_mode_approver && m.safeMode">
						<translate>Block</translate>
					</el-col>
					<el-col :span="6" v-show="!m.safe.safe_mode_approver && !m.safeMode">
						<translate>Green Light</translate>
					</el-col>
					<el-col :span="6" v-show="m.safe.safe_mode_approver && m.safeMode && (m.safe.safe_mode_application == 3 || m.safe.safe_mode_application == 4)">
						<translate> : Block</translate>
					</el-col>
					<el-col :span="6" v-show="m.safe.safe_mode_approver && m.safeMode && m.safe.safe_mode_application == 0">
						<translate>: block/pending audit</translate>
					</el-col>
					<el-col :span="6" v-show="m.safe.safe_mode_approver && m.safeMode && m.safe.safe_mode_application == 1">
						<translate>: block/passed</translate>
					</el-col>
					<el-col :span="6" v-show="m.safe.safe_mode_approver && m.safeMode && m.safe.safe_mode_application == 2">
						<translate>: block/not passed</translate>
					</el-col>
					<el-col :span="6" v-show="m.safe.safe_mode_approver && !m.safeMode && m.safe.safe_mode_application == 1">
						<translate>: green light/passed</translate>
					</el-col>
					<el-button :span="6" class="apply-safe" v-show="m.safe.safe_mode_approver && m.safeMode && (m.safe.safe_mode_application == 3 || m.safe.safe_mode_application == 4)" @click="startApplyEvent(clickRowInfo.m, 'ecs')">
						<translate>Apply Non-security mode</translate>
					</el-button>
					<el-button :span="3" v-show="!m.safe.safe_mode_approver || (m.safe.safe_mode_approver && m.safe.safe_mode_application == 1)" @click.stop="switchSafeMode">
						<translate>Switch</translate>
					</el-button>
					<el-button :span="3" class="apply-safe" v-show="m.safe.safe_mode_approver && m.safeMode && m.safe.safe_mode_application == 2" @click="startApplyEvent(clickRowInfo.m, 'ecs')">
						<translate>Reapply</translate>
					</el-button>
				</el-form-item>
				<el-form-item :label="attrText.validTime">
					<el-select @change="changeExpireTime" v-model="m.expire" class="code-input">
						<el-option value="day" :label="attrText.oneDay"></el-option>
						<el-option value="month" :label="attrText.oneMonth"></el-option>
						<el-option value="custom" :label="attrText.customize"></el-option>
					</el-select>
					<el-date-picker v-if="m.expire === 'custom'" v-model="m.validTime" type="datetime" class="code-input" :picker-options="safeOptions" :placeholder="attrText.selectDate"> </el-date-picker>
				</el-form-item>
				<el-form-item :label="attrText.allowIP" v-if="m">
					<el-input class="code-input" v-model="m.client_ip" @change="ipInput" :placeholder="attrText.tipallowIp"></el-input>
					<translate tag="div">IPs are separated by semicolons ";", and there is no limit if left blank</translate>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="showModal.showCreateModal = false">
					<translate>Cancel</translate>
				</el-button>
				<el-button type="primary" @click="createCode" :loading="m.saving" :disabled="m.validTime < new Date().getTime()">
					<translate>Confirm</translate>
				</el-button>
			</div>
		</el-dialog>
		<!--修改code dialog-->
		<el-dialog :title="attrText.modifyCode" :visible.sync="showModal.modifyCreateModal" custom-class="modify-code-dialog">
			<el-form :label-width="formLabelWidth">
				<el-form-item :label="attrText.securityMode" prop="safeMode" v-if="codeObj && codeObj.safe.network_safe_mode && codeObj && codeObj.resource.resource_type === 'ecs' && codeObj.os === 'linux'">
					<el-col :span="6" v-show="!codeObj.safe.safe_mode_approver && codeObj.safeMode">
						<translate>Block</translate>
					</el-col>
					<el-col :span="6" v-show="!codeObj.safe.safe_mode_approver && !codeObj.safeMode">
						<translate>Green Light</translate>
					</el-col>
					<el-col :span="6" v-show="codeObj.safe.safe_mode_approver && codeObj.safeMode && (codeObj.safe.safe_mode_application == 3 || codeObj.safe.safe_mode_application == 4)">
						<translate> : Block</translate>
					</el-col>
					<el-col :span="6" v-show="codeObj.safe.safe_mode_approver && codeObj.safeMode && codeObj.safe.safe_mode_application == 0">
						<translate>: block/pending audit</translate>
					</el-col>
					<el-col :span="6" v-show="codeObj.safe.safe_mode_approver && codeObj.safeMode && codeObj.safe.safe_mode_application == 1">
						<translate>: block/passed</translate>
					</el-col>
					<el-col :span="6" v-show="codeObj.safe.safe_mode_approver && codeObj.safeMode && codeObj.safe.safe_mode_application == 2">
						<translate>: block/not passed</translate>
					</el-col>
					<el-col :span="7" v-show="codeObj.safe.safe_mode_approver && !codeObj.safeMode && codeObj.safe.safe_mode_application == 1">
						<translate>: green light/passed</translate>
					</el-col>
					<el-button :span="6" class="apply-safe" v-show="codeObj.safe.safe_mode_approver && codeObj.safeMode && (codeObj.safe.safe_mode_application == 3 || codeObj.safe.safe_mode_application == 4)" @click="startApplyEvent(clickRowInfo.m, 'ecs')">
						<translate>Apply Non-security mode</translate>
					</el-button>
					<el-button :span="3" v-show="!codeObj.safe.safe_mode_approver || (codeObj.safe.safe_mode_approver && codeObj.safe.safe_mode_application == 1)" @click.stop="switchModifySafeMode">
						<translate>Switch</translate>
					</el-button>
					<el-button :span="3" class="apply-safe" v-show="codeObj.safe.safe_mode_approver && codeObj.safeMode && codeObj.safe.safe_mode_application == 2" @click="startApplyEvent(clickRowInfo.m, 'ecs')">
						<translate>Reapply</translate>
					</el-button>
				</el-form-item>
				<el-form-item :label="attrText.validTime" prop="validTime">
					<el-select class="code-input" v-model="modifyTime.type" @change="modifyCodeSelectChange">
						<el-option value="day" :label="attrText.oneDay"></el-option>
						<el-option value="month" :label="attrText.oneMonth"></el-option>
						<el-option value="custom" :label="attrText.customize"></el-option>
					</el-select>
					<el-date-picker v-if="modifyTime.type === 'custom'" v-model="modifyTime.time" type="datetime" class="code-input" @change="modifyTime.isSelectTime = false" :picker-options="safeOptions" :placeholder="attrText.selectDate"> </el-date-picker>
					<p v-if="modifyTime.isSelectTime" style="color: red">{{ attrText.selectDate }}</p>
				</el-form-item>
				<el-form-item :label="attrText.allowIP" v-if="codeObj">
					<el-input class="code-input" v-model="codeObj.allow_ip" :placeholder="attrText.tipallowIp"></el-input>
					<translate tag="div">IPs are separated by semicolons ";", and there is no limit if left blank</translate>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="showModal.modifyCreateModal = false">
					<translate>Cancel</translate>
				</el-button>
				<el-button type="primary" @click="modifyCode">
					<translate>Confirm</translate>
				</el-button>
			</div>
		</el-dialog>
		<!--临时授权-->
		<el-dialog v-if="tempObj" :title="attrText.temporaryAuthorize" :visible.sync="showModal.showTempModal" @close="closeTempModal()">
			<el-form label-width="200px" :model="tempObj" :rules="rules" ref="tempObjForm">
				<el-form-item :label="attrText.validTime" class="m-b-none" prop="expire_time">
					<el-select class="code-input" v-model="tempObj.expire_time">
						<el-option value="30" :label="`30 ${attrText.minutes}`"></el-option>
						<el-option value="60" :label="`60 ${attrText.minutes}`"></el-option>
						<el-option value="120" :label="`120 ${attrText.minutes}`"></el-option>
						<el-option value="customize" :label="attrText.customize"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item class="p-l-200" v-if="tempObj.expire_time == 'customize'" prop="expire_time_customize">
					<el-input class="code-input-time" v-model.number="tempObj.expire_time_customize" type="number"></el-input>
					<translate>minutes</translate>
				</el-form-item>
				<el-form-item class="p-l-200">
					<translate>This expiration time is not limited by the SSH or RDP timeout set on the host.</translate>
				</el-form-item>
				<el-form-item :label="attrText.userName" v-if="!tempObj.showNewTemp && tempObj.autologin" prop="username">
					<el-select class="code-input" v-model="tempObj.username">
						<el-option value="" :label="attrText.select" v-show="tempObj.usernameList.length > 1"></el-option>
						<el-option v-for="user in tempObj.usernameList" :key="user.id" :value="user"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="attrText.serverUser" prop="username" v-if="tempObj.showNewTemp || (!tempObj.showNewTemp && !tempObj.autologin)">
					<el-input class="code-input" v-model="tempObj.username" auto-complete="new-password" @input="onTempCredentialChange"></el-input>
				</el-form-item>
				<el-form-item :label="attrText.serverPsw" prop="psw" v-if="tempObj.showNewTemp || (!tempObj.showNewTemp && !tempObj.autologin)">
					<div class="psw-test-wrap">
						<el-input class="code-input-psw" v-model="tempObj.psw" auto-complete="new-password" type="password" @input="onTempCredentialChange"></el-input>
						<el-button class="test-btn" :loading="tempTesting" @click="testPasswordConnection">
							<span v-if="tempTesting"></span>
							<translate v-else>Test</translate>
						</el-button>
						<span class="test-status test-status-success" v-if="tempTestPassed">
							<i class="el-icon-circle-check"></i>
							<translate>Test passed</translate>
						</span>
					</div>
				</el-form-item>
				<el-form-item :label="attrText.allowIP" prop="allow_ip">
					<el-input class="code-input" v-model="tempObj.allow_ip" :pattern="allowIPPattern" auto-complete="off"></el-input>
					<translate style="margin-left: 10px"> IPs are separated by semicolons ";", and there is no limit if left blank </translate>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeTempModal()">
					<translate>Cancel</translate>
				</el-button>
				<el-button type="primary" :loading="tempObj.saving" :disabled="tempNeedTest && !tempTestPassed" @click="tempAuth">
					<translate>Confirm</translate>
				</el-button>
			</div>
		</el-dialog>
		<!--创建临时授权 2-->
		<el-dialog :title="attrText.temporaryAuthorize" :visible.sync="showModal.showTempModalSuccess" @close="closeTempModalSuccess">
			<el-form :label-width="formLabelWidth" v-if="tempWinObj">
				<div v-if="tempWinObj.type === 'linux'">
					<el-form-item :label="attrText.connectAddress">
						<span>{{ tempWinObj.linkUrl }}</span>
						<a v-clipboard:copy="tempWinObj.linkUrl" v-clipboard:success="copySuccess" v-clipboard:error="copyError">
							<translate>Copy</translate>
						</a>
					</el-form-item>
					<el-form-item :label="attrText.temporarypsw" v-if="tempWinObj.tmpPsw">
						<span>{{ tempWinObj.tmpPsw }}</span>
						<a v-clipboard:copy="tempWinObj.tmpPsw" v-clipboard:success="copySuccess" v-clipboard:error="copyError">
							<translate>Copy</translate>
						</a>
					</el-form-item>
					<div class="p-l-note"><translate>Note: The link is only available once (Valid time:</translate>{{ tempObj.expire_time === 'customize' ? Math.round(tempObj.expire_time_customize) : tempObj.expire_time }} <translate>minutes)</translate></div>
				</div>
				<div class="temp-win" v-if="tempWinObj.type === 'win32'">
					<el-row>
						<el-col :span="10" class="text-right">
							<translate>Host</translate>
							<span>:</span></el-col
						>
						<el-col class="p-l-15" :span="8">{{ tempWinObj.host }}</el-col>
						<el-col :span="3">
							<a v-clipboard:copy="tempWinObj.host" v-clipboard:success="copySuccess" v-clipboard:error="copyError">
								<translate>Copy</translate>
							</a>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10" class="text-right">
							<translate>Temporary user</translate>
							<span>:</span></el-col
						>
						<el-col class="p-l-15" :span="8">{{ tempWinObj.tmpUsername }}</el-col>
						<el-col :span="3">
							<a v-clipboard:copy="tempWinObj.tmpUsername" v-clipboard:success="copySuccess" v-clipboard:error="copyError">
								<translate>Copy</translate>
							</a>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10" class="text-right">
							<translate>Temporary password</translate>
							<span>:</span></el-col
						>
						<el-col class="p-l-15" :span="8">{{ tempWinObj.tmpPsw }}</el-col>
						<el-col :span="3">
							<a v-clipboard:copy="tempWinObj.tmpPsw" v-clipboard:success="copySuccess" v-clipboard:error="copyError">
								<translate>Copy</translate>
							</a></el-col
						>
					</el-row>
					<div class="text-center"><translate>Note: The user and password are only available once (Valid time:</translate>{{ tempObj.expire_time === 'customize' ? Math.round(tempObj.expire_time_customize) : tempObj.expire_time }} <translate>minutes)</translate></div>
				</div>
			</el-form>
		</el-dialog>
		<!-- 预览SQL -->
		<el-dialog :title="attrText.previewSQL" :visible.sync="showModal.previewSQL">
			<CodemirrorEditor v-if="showModal.previewSQL" ref="codemirrorEditor" @input="onEditorInput" :value="verifyData.sql" />
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showModal.previewSQL = false">
					<translate>Confirm</translate>
				</el-button>
			</div>
		</el-dialog>

		<!-- 日志查看弹窗 -->
		<el-dialog title="日志内容查看" :visible.sync="viewLogShow" width="90%" top="20px" @close="closeViewLogDialog">
			<div class="log-view-content" v-loading="viewLogLoading" element-loading-text="加载日志内容中...">
				<pre>{{ logContent }}</pre>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" v-clipboard:copy="logContent" v-clipboard:success="copySuccess" v-clipboard:error="copyError"><translate>Copy</translate></el-button>
				<el-button type="" @click="viewLogShow = false"><translate>Close</translate></el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import STORE_CONST from '../../store/consts'
import { Utils, baseUrl } from '../../config'
import WorkgroupOnlineConnection from './model/workgroup-online-connection'
import WorkgroupConnectLogs from './model/workgroup-connection-logs'
import WorkGroupConnection from './model/workgroup-connection'
import WorkgroupApply from './model/workgroup-apply'
import LinuxConfig from './model/linux-config'
import ManageCode from './model/manage-code'
import Check from './model/check.vue'
import WorkGroupAssist from './model/workgroup-assist'
import CodemirrorEditor from './model/code-mirror-editor.vue'

import Base64 from 'js-base64'
import Utility from '../../Utils'
import moment from '../../../node_modules/moment/src/moment'
export default {
	name: 'WorkGroupDetail',
	data() {
		const checkExpireTime = (rule, value, callback) => {
			let maxTunnelExpireTime = 0
			this.clickRowInfo.m.max_tunnel_expire_time ? (maxTunnelExpireTime = this.clickRowInfo.m.max_tunnel_expire_time / 60) : 0
			if (value < 1) {
				callback(new Error(this.$gettext('In order to ensure the availability of the code, the maximum effective time cannot be less than 1 minutes')))
			} else if (maxTunnelExpireTime && value > maxTunnelExpireTime) {
				callback(new Error(this.$gettext('the effective time has exceeded the maximum effective time of the code set by the administrator: ') + maxTunnelExpireTime + this.$gettext('minutes')))
			} else {
				callback()
			}
		}
		return {
			verifyData: {},
			loading: true,
			downloadUrl: '',
			activeTabName: this.$route.query.type || 'ecs',
			workgroup: null,
			instances: [],
			instancesList: {
				totalPage: 1,
				pageSize: 10,
				currentPage: 1,
			},
			databasesList: {
				totalPage: 1,
				pageSize: 10,
				currentPage: 1,
			},
			databases: [],
			tunnelCode: null,
			searchForm: {
				type: 'q_name',
				key: '',
			},
			currentRightPanel: null,
			rightPanelData: null,
			showModal: {
				showCreateModal: false,
				modifyCreateModal: false,
				showTempModal: false,
				showTempModalSuccess: false,
				disCreateModal: true,
				previewSQL: false,
			},
			formLabelWidth: '120px',
			rules: {
				username: [{ required: true, message: this.$gettext('Please input the username'), trigger: 'change' }],
				psw: [{ required: true, message: this.$gettext('Please input the password'), trigger: 'change' }],
				allow_ip: [
					{
						pattern: /^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}[:;])*(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})$/,
						message: this.$gettext('please input the right IP'),
						trigger: 'change',
					},
				],
				expire_time_customize: [
					{ required: true, type: 'number', message: this.$gettext('Please input the expire time'), trigger: 'change' },
					{ validator: checkExpireTime, trigger: 'change' },
				],
			},
			allowIPPattern: /^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}[:;])*(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})$/,
			clickRowInfo: {},
			m: {
				resource: {},
				network: {},
				safe: {},
				validTime: new Date(),
				expire: '',
			},
			codeObj: null,
			modifyTime: {
				type: 'day',
				time: '',
				isSelectTime: false,
			},
			safeOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now()
				},
			},
			codeId: '',
			tempObj: {
				expire_time: '30',
				expire_time_customize: '',
				username: '',
				psw: '',
				allow_ip: '',
				saving: false,
			},
			tempSuccessObj: null,
			tempWinObj: null,
			testcopy: false,
			// 临时授权密码测试状态
			tempTesting: false,
			tempTestPassed: false,

			// 日志查看相关
			viewLogShow: false,
			viewLogLoading: false,
			logContent: '',
		}
	},
	computed: {
		attrText() {
			return this.initAttrText()
		},
		// 临时授权弹框是否需要先测试账号密码（当显示账号密码输入框时）
		tempNeedTest() {
			return this.tempObj.showNewTemp || (!this.tempObj.showNewTemp && !this.tempObj.autologin)
		},
	},
	mounted() {
		this.setSearchData()
		this.getProjectDetail()
		this.getProjectResource(1)
	},
	methods: {
		setSearchData() {
			const _query = this.$route.query
			if (Object.keys(_query).length) {
				for (let k in _query) {
					if (k == 'q_ip' || k == 'q_name') {
						this.searchForm.type = k
						this.searchForm.key = _query[k]
					}
				}
			}
		},
		onEditorInput(code) {
			// 编辑器输入事件
			this.verifyData.sql = code
		},

		initAttrText() {
			return {
				validTime: this.$gettext('Valid Time'),
				serverUser: this.$gettext('Server User'),
				serverPsw: this.$gettext('Server Password'),
				allowIP: this.$gettext('Allow IP'),
				thirty: this.$gettext('Thirty minutes'),
				minutes: this.$gettext('minutes'),
				name: this.$gettext('Name'),
				userName: this.$gettext('Username'),
				select: this.$gettext('select'),
				selectDate: this.$gettext('Please Select Date'),
				dabaseName: this.$gettext('Database Name'),
				action: this.$gettext('Action'),
				instance: this.$gettext('Instance'),
				cluster: this.$gettext('Cluster'),
				avaliableCode: this.$gettext('Avaliable Code'),
				onlineSession: this.$gettext('Online Sessions'),
				connectLog: this.$gettext('Connection Log'),
				database: this.$gettext('Database'),
				createCode: this.$gettext('Create Code'),
				modifyCode: this.$gettext('Modify Code'),
				securityMode: this.$gettext('Security Mode'),
				temporaryAuthorize: this.$gettext('Temporary Authorize'),
				temporarypsw: this.$gettext('Temporary Password'),
				connectAddress: this.$gettext('Connection Address'),
				oneDay: this.$gettext('one day later'),
				oneMonth: this.$gettext('one month later'),
				customize: this.$gettext('customize'),
				tipallowIp: this.$gettext('Please input the allow IP'),
				unavailable: this.$gettext('Unavailable'),
				available: this.$gettext('Available'),
				notSupport: this.$gettext('The new version of the agent does not support the database connection, coming soon.'),
				previewSQL: this.$gettext('Preview SQL'),
				test: this.$gettext('Test'),
				testPassed: this.$gettext('Test passed'),
			}
		},
		exportAnsible() {
			this.downloadUrl = baseUrl.apiUrl + '/project/' + this.$route.params.id + '/hosts?type=ansible&export=true&t=' + new Date().getTime()
		},
		// 创建code有效时间type切换计算时间戳
		changeExpireTime() {
			if (this.m.expire === 'day') {
				this.m.validTime = Date.now() + 24 * 60 * 60 * 1000
			} else if (this.m.expire === 'month') {
				this.m.validTime = new Date().setMonth(new Date().getMonth() + 1)
			} else {
				this.m.validTime = new Date().getTime() + 30 * 60 * 1000
			}
		},
		// 创建code 时间验证
		timeInput(e) {
			if (/\d/.test(e)) {
				this.showModal.disCreateModal = false
				if (!this.m.client_ip || (this.m.client_ip && this.allowIPPattern.test(this.m.client_ip))) {
					this.showModal.disCreateModal = false
				} else {
					this.showModal.disCreateModal = true
				}
			} else {
				this.showModal.disCreateModal = true
			}
		},
		// 创建code 允许IP 验证
		ipInput(e) {
			if (this.showModal.showCreateModal) {
				if (/\d/.test(this.m.validTime)) {
					if (this.m.client_ip) {
						if (!this.m.client_ip || (this.m.client_ip && this.allowIPPattern.test(e))) {
							this.showModal.disCreateModal = false
						} else {
							this.showModal.disCreateModal = true
						}
					} else {
						this.showModal.disCreateModal = false
					}
				}
			}
		},
		closeTempModal() {
			this.showModal.showTempModal = false
			// 创建成功后会打开成功弹窗（其展示依赖 tempObj 的有效时间），此时不重置，由成功弹窗关闭时重置
			if (!this.showModal.showTempModalSuccess) {
				this.resetTempForm()
			}
		},
		// 重置临时授权表单数据
		resetTempForm() {
			this.tempObj = Object.assign({}, this.tempObj, {
				expire_time: '30',
				expire_time_customize: '',
				username: '',
				psw: '',
				allow_ip: '',
				saving: false,
			})
			this.tempTesting = false
			this.tempTestPassed = false
			this.$nextTick(() => {
				if (this.$refs['tempObjForm']) {
					this.$refs['tempObjForm'].resetFields()
				}
			})
		},
		// 账号或密码变更时，重置测试通过状态
		onTempCredentialChange() {
			this.tempTestPassed = false
		},
		// 测试主机账号密码连接
		testPasswordConnection() {
			if (!this.tempObj.username) {
				this.$notify({
					message: this.$gettext('Please input the username'),
					type: 'warning',
				})
				return false
			}
			if (!this.tempObj.psw) {
				this.$notify({
					message: this.$gettext('Please input the password'),
					type: 'warning',
				})
				return false
			}
			this.tempTesting = true
			const params = {
				project_resource_id: this.clickRowInfo.m.project_resource_id,
				username: this.tempObj.username,
				passwd: this.tempObj.psw,
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.TEST_PASSWORD_CONNECTION, params).then(
				(res) => {
					this.tempTesting = false
					if (res && res.result === 'enable') {
						this.tempTestPassed = true
						this.$notify({
							message: (res && res.msg) || this.$gettext('Test failed'),
							type: 'success',
						})
					} else {
						this.tempTestPassed = false
						this.$notify({
							message: (res && res.msg) || this.$gettext('Test failed'),
							type: 'error',
						})
					}
				},
				(err) => {
					this.tempTesting = false
					this.tempTestPassed = false
					this.$notify({
						message: (err && err.err) || this.$gettext('Test failed'),
						type: 'error',
					})
				},
			)
		},
		copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success',
			})
			e.clearSelection()
		},
		copyError(e) {
			this.$notify({
				message: this.$gettext('Copy Failed!'),
				type: 'failed',
			})
		},
		onClosePanel() {
			this.currentRightPanel = null
			this.rightPanelData = null
		},
		// 连接内部点击申请回调打开申请modal
		startApplyEvent(row) {
			console.log('row', row)
			this.onClosePanel()
			this.showModal.showCreateModal = false
			this.showModal.modifyCreateModal = false
			this.startApply(row, 'ecs')
		},
		onShowModal(params) {
			this.showModal[params.name] = true
			console.log('clickRowInfo', this.clickRowInfo)
			if (params.name === 'showCreateModal') {
				this.$store.dispatch(STORE_CONST.WORKGROUP.GET_PROJECT_RESOURCE_INFO, this.clickRowInfo.m.project_resource_id).then((res) => {
					this.$store.dispatch(STORE_CONST.WORKGROUP.GET_CLIENT_IP).then((data) => {
						res.safeMode = true
						res.client_ip = data.client_ip
						res.extension = JSON.parse(res.resource.extension)
						this.m = Object.assign({}, this.m, res)
						console.log('mmmm->', this.m)
					})
				})
			} else if (params.name === 'modifyCreateModal') {
				this.$store.dispatch(STORE_CONST.WORKGROUP.GET_CODE_INFO, params.code).then((res) => {
					res.safeMode = res.safe_mode
					this.oldCodeObj = Object.clone(res)
					this.codeObj = Object.clone(res)
					this.modifyTime.time = res.expire_time * 1000
				})
			} else if (params.name === 'showTempModal') {
				let showNewTemp = Utility.Utils.getAgentVersion(this.clickRowInfo.m.agent_version) >= '3.0.0'
				let autologin = this.clickRowInfo.m.autologin
				// let username = JSON.parse(this.clickRowInfo.m.resource.extension).username
				let username = 'hhhhh'
				let defaultUserName = ''
				let userNameList = []
				if (username) {
					userNameList = username.split(';')
					if (userNameList.length < 2) {
						defaultUserName = username
					}
					defaultUserName = ''
				} else {
					userNameList = ['root']
					defaultUserName = 'root'
				}
				this.tempObj = Object.assign({}, this.tempObj, {
					usernameList: userNameList,
					username: defaultUserName,
					autologin: autologin,
					showNewTemp: showNewTemp,
				})
				// 重置密码测试状态
				this.tempTesting = false
				this.tempTestPassed = false
				this.$store.dispatch(STORE_CONST.WORKGROUP.GET_CLIENT_IP).then((data) => {
					this.$set(this.tempObj, 'allow_ip', data.client_ip)
				})
			} else if (params.name === 'previewSQL') {
				this.verifyData = params.data
			}
		},
		onShowConnectionLogs(row) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkGroupConnectLogs' ? 0 : 300
			this.currentRightPanel = WorkgroupConnectLogs
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = row
				}, time)
			})
		},
		onShowConnect(row) {
			this.codeId = row.project_resource_id
			this.$set(this.clickRowInfo, 'm', row)
			const data = {
				agentVersion: Utility.Utils.getAgentVersion(row.agent_version),
				// projectName: row.project.project_name,
				resourceName: row.name,
				// projectId: row.project.id,
				projectResourceId: row.project_resource_id,
				row: row,
			}
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkGroupConnection' ? 0 : 300
			this.currentRightPanel = WorkGroupConnection
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = data
				}, time)
			})
		},
		// 选择协助方式
		onSelectAssistance(c) {
			this.onShowAssist(c)
		},
		onShowAssist(command) {
			console.log('--comand--', command)
			const data = {
				assistType: command.key,
				agentVersion: Utility.Utils.getAgentVersion(command.row.agent_version),
				projectName: command.row.project,
				resourceName: command.row.name,
				projectId: this.$route.params.id,
				projectResourceId: command.row.project_resource_id,
			}
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkGroupAssist' ? 0 : 300
			this.currentRightPanel = WorkGroupAssist
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = data
				}, time)
			})
		},
		onShowConnections(row) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkGroupOnlineConnection' ? 0 : 300
			this.currentRightPanel = WorkgroupOnlineConnection
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = row
				}, time)
			})
		},
		linuxConfig(row) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'LinuxConfig' ? 0 : 300
			this.currentRightPanel = LinuxConfig
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = row
				}, time)
			})
		},
		manageCode(row) {
			// console.log('magecode-->', row.id)
			this.codeId = row.project_resource_id
			this.$set(this.clickRowInfo, 'm', row)
			row.resource_type = this.$route.query.type
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ManageCode' ? 0 : 300
			this.currentRightPanel = ManageCode
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = row
				}, time)
			})
		},
		check(row) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ManageReport' ? 0 : 300
			this.currentRightPanel = Check
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = row
				}, time)
			})
		},
		startApply(row, type) {
			console.log('row', row, this.currentRightPanel)
			row.applyType = type
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupApply' ? 0 : 300
			this.currentRightPanel = WorkgroupApply
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = row
				}, time)
			})
		},
		switchSafeMode() {
			if (this.m.safeMode) {
				this.$set(this.m, 'safeMode', false)
				// this.m.safeMode = false
			} else {
				this.$set(this.m, 'safeMode', true)
				// this.m.safeMode = true
			}
		},
		switchModifySafeMode() {
			if (this.codeObj.safeMode) {
				this.$set(this.codeObj, 'safeMode', false)
				// this.m.safeMode = false
			} else {
				this.$set(this.codeObj, 'safeMode', true)
				// this.m.safeMode = true
			}
		},
		// 创建code提交
		createCode() {
			console.log('current valid time:::', this.clickRowInfo.m.max_tunnel_expire_time)
			if (this.clickRowInfo.m.max_tunnel_expire_time && this.m.validTime > new Date().getTime() + this.clickRowInfo.m.max_tunnel_expire_time * 1000) {
				this.$notify({
					type: 'error',
					message: this.$gettext("Set failed.The admin has set the cluster's effective time to no more than ") + moment(new Date().getTime() + this.clickRowInfo.m.max_tunnel_expire_time * 1000).format('YYYY-MM-DD HH:mm:ss'),
				})
				return false
			}
			this.m.saving = true
			let params = {
				project_resource_id: this.m.id,
				allow_ip: this.m.client_ip,
				expire: parseFloat(((this.m.validTime - new Date().getTime()) / (60 * 60 * 1000)).toFixed(2)),
			}
			if (this.m.safe.network_safe_mode && this.m.resource.resource_type === 'ecs' && this.m.extension.os === 'linux') {
				if (!this.m.safeMode) {
					params.safe_mode = 0
				} else {
					params.safe_mode = 1
				}
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.CREATE_CODE, params).then(
				(res) => {
					this.m.saving = false
					this.showModal.showCreateModal = false
					this.$refs['rightPanel'].getTunelInfo(this.codeId)
					this.$notify({
						type: 'success',
						message: this.$gettext('Create code suceessfully!'),
					})
				},
				() => {
					this.m.saving = false
				},
			)
		},
		modifyCodeSelectChange(name) {
			if (name === 'custom') {
				this.modifyTime.time = this.codeObj.expire_time * 1000
			}
		},
		// 修改code提交
		modifyCode() {
			if (this.modifyTime.type === 'day') {
				this.modifyTime.time = (Date.now() + 24 * 60 * 60 * 1000) / 1000
			} else if (this.modifyTime.type === 'month') {
				this.modifyTime.time = (Date.now() + 30 * 24 * 60 * 60 * 1000) / 1000
			} else {
				console.log('this.modifyTime.time', !this.modifyTime.time)
				if (!this.modifyTime.time) {
					this.modifyTime.isSelectTime = true
					return false
				} else {
					this.modifyTime.isSelectTime = false
					this.modifyTime.time = this.modifyTime.time / 1000
				}
			}
			if (this.clickRowInfo.m.max_tunnel_expire_time && this.modifyTime.time > this.codeObj.create_time + this.clickRowInfo.m.max_tunnel_expire_time) {
				this.$notify({
					type: 'error',
					message: this.$gettext("Set failed.The admin has set the cluster's effective time to no more than ") + moment((this.codeObj.create_time + this.clickRowInfo.m.max_tunnel_expire_time) * 1000).format('YYYY-MM-DD HH:mm:ss'),
				})
				this.modifyCodeSelectChange('custom')
				return false
			}
			let params = {
				expire_time: this.modifyTime.time,
			}
			if (this.oldCodeObj.safeMode !== this.codeObj.safeMode) {
				if (this.codeObj.safeMode) {
					params.safe_mode = 1
				} else {
					params.safe_mode = 0
				}
			}
			if (this.oldCodeObj.allow_ip !== this.codeObj.allow_ip) {
				params.allow_ip = this.codeObj.allow_ip
			}
			let obj = {
				code: this.codeObj.code,
				data: params,
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.MODIFY_CODE, obj).then((res) => {
				this.showModal.modifyCreateModal = false
				this.modifyTime.type = 'day'
				this.$refs['rightPanel'].getTunelInfo(this.codeId)
				this.$notify({
					type: 'success',
					message: this.$gettext('Modify code successfully!'),
				})
			})
		},
		closeTempModalSuccess() {
			this.tempWinObj = null
			setTimeout(() => {
				this.resetTempForm()
			}, 300)
			this.$refs['rightPanel'].getTunelInfo(this.codeId)
		},
		tempAuth() {
			this.$refs['tempObjForm'].validate((valid) => {
				if (valid) {
					this.tempObj.saving = true
					let params = {
						project_resource_id: this.clickRowInfo.m.project_resource_id,
						tmpShare: true,
						allow_ip: this.tempObj.allow_ip,
						expire: this.tempObj.expire_time === 'customize' ? Number(Number(this.tempObj.expire_time_customize) / 60) : Number(this.tempObj.expire_time / 60),
					}
					if (this.tempObj.psw) {
						params.passwd = this.tempObj.psw
					}
					if (this.tempObj.expire_time !== 'customize' && this.clickRowInfo.m.max_tunnel_expire_time) {
						console.log('--this.', this.tempObj.expire_time, this.clickRowInfo.m.max_tunnel_expire_time / 60)
						if (this.tempObj.expire_time > this.clickRowInfo.m.max_tunnel_expire_time / 60) {
							this.$notify({
								message: this.$gettext('Creation failed, the effective time has exceeded the maximum effective time of the code set by the administrator'),
								type: 'error',
							})
							this.tempObj.saving = false
							return false
						}
					}
					this.$store.dispatch(STORE_CONST.WORKGROUP.GET_TUNNEL_INFO, params).then(
						(d) => {
							this.tempObj.saving = false
							this.showModal.showTempModal = false
							console.log('tempsuccess:::', d)
							this.tempSuccessObj = d
							let _connectData = {
								code: d.code,
								host: d.agent.host,
								agentVersion: Utility.Utils.getAgentVersion(d.agent.version),
								tmp_passwd: d.tmp_passwd,
							}
							this.tempWinObj = {}
							this.tempWinObj.tmpPsw = _connectData.tmp_passwd
							if (d.os === 'linux') {
								_connectData.type = 'linux'
								_connectData.webPort = d.agent.web_port
								_connectData.path = '/wetty/ssh'
							} else if (d.os === 'win32') {
								_connectData.type = 'win32'
								_connectData.rdpPort = d.agent.rdp_port
								_connectData.path = '/webrdp'
								this.tempWinObj.host = _connectData.host + ':' + _connectData.rdpPort
								this.tempWinObj.tmpUsername = _connectData.code + '_' + this.tempObj.username
							}
							let agentVersionFirst = parseInt(_connectData.agentVersion.split('.')[0])
							if (d.os === 'linux') {
								this.tempWinObj.linkUrl = 'http://' + _connectData.host + ':' + _connectData.webPort + _connectData.path + '/' + Base64.Base64.encode(d.code) + '/' + this.tempObj.username
								if (!isNaN(agentVersionFirst) && agentVersionFirst > 1) {
									this.tempWinObj.linkUrl = 'http://' + _connectData.host + ':' + _connectData.webPort + '/?code=' + Base64.Base64.encode(d.code) + '&user=' + this.tempObj.username
								}
							} else if (d.os === 'win32') {
								this.tempWinObj.linkUrl = 'http://' + _connectData.host + ':' + _connectData.rdpPort + _connectData.path + '/' + Base64.Base64.encode(d.code) + '/' + 'none' + '/' + this.tempObj.username
							}
							this.tempWinObj.type = d.os
							console.log('tempObj', this.tempWinObj, this.tempWinObj.linkUrl)
							this.showModal.showTempModalSuccess = true
						},
						() => {
							this.tempObj.saving = false
						},
					)
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		onSearch() {
			const params = {}
			if (this.searchForm.key !== '' && this.searchForm.type) {
				params[this.searchForm.type] = this.searchForm.key
			}
			if (this.$route.query.type !== '' && this.$route.query.type) {
				params.type = this.$route.query.type
			}

			this.$router.push({ path: this.$route.path, query: params })
		},
		onClickTab(tab) {
			this.$router.push({ name: 'workgroupdetail', query: { type: tab.name } })
			this.searchForm = {
				type: 'q_name',
				key: '',
			}
			this.activeTabName = this.$route.query.type || 'ecs'
			this.getProjectResource()
		},
		getProjectDetail() {
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_WORKGROUP_DETAIL, this.$route.params).then((res) => {
				this.workgroup = res
			})
		},
		changeProjectPage(page) {
			this.getProjectResource(page)
		},

		getProjectResource(pageIndex) {
			this.loading = true
			let params = {
				id: this.$route.params.id,
				params: {
					page: pageIndex || 1,
					type: this.activeTabName,
				},
			}
			if (this.searchForm.key) {
				params.params[this.searchForm.type] = this.searchForm.key
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.LIST_WORKGROUP_RESOURCE, params).then(
				(res) => {
					this.loading = false
					this.instances = []
					this.databases = []
					if (this.activeTabName === 'ecs') {
						this.instances = res.objects
						this.instancesList.totalPage = res.total_pages
						this.instancesList.currentPage = res.page
					} else if (this.activeTabName === 'rds') {
						this.databases = res.objects
						this.databasesList.totalPage = res.total_pages
						this.databasesList.currentPage = res.page
					}
				},
				() => {
					this.loading = false
				},
			)
		},
		getOnlineConnection() {
			const params = {
				page: 1,
				page_size: Utils.config.maxPageSize,
			}
			this.$store.dispatch(STORE_CONST.DASHBOARD.GET_ONLINE_CONNECT, params).then((res) => {
				if (res && res.length) {
					const resourceObj = res.groupBy('project_resource_id')
					if (this.instances && this.instances.length) {
						this.instances.forEach((item) => {
							this.$set(item, 'connects', resourceObj[item.id] || [])
						})
					}
					if (this.databases && this.databases.length) {
						this.databases.forEach((item) => {
							this.$set(item, 'connects', resourceObj[item.id] || [])
						})
					}
					console.log('onlineConnec', this.instances)
				}
			})
		},
		getTunnelCode(ids) {
			const params = {
				results_per_page: Utils.config.maxPageSize,
				q: {
					filters: [
						{
							name: 'project_resource_id',
							op: 'in',
							val: ids,
						},
						{
							name: 'account_id',
							op: 'eq',
							val: this.$store.getters.account.id,
						},
						{
							name: 'type',
							op: 'eq',
							val: '',
						},
						{
							name: 'status',
							op: 'eq',
							val: 'enable',
						},
						{
							name: 'expire_time',
							op: '>',
							val: Math.floor(Date.now() / 1000),
						},
					],
				},
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_TUNNEL_CODE, params).then((res) => {
				const codeObj = res.objects.groupBy('project_resource_id')
				if (ids.length > 1) {
					this.tunnelCode = codeObj
				} else {
					this.tunnelCode = this.tunnelCode || {}
					this.$set(this.tunnelCode, ids[0], res.objects)
				}
			})
		},
		reloadTunnelCode(id) {
			this.getTunnelCode(id)
		},
		reloadOnlineConnects() {
			this.getOnlineConnection()
		},
		reloadPojectResource() {
			if (this.activeTabName === 'ecs') {
				this.getProjectResource(this.instancesList.currentPage)
			} else {
				this.getProjectResource(this.databasesList.currentPage)
			}
		},
		hideStr(str) {
			return Utility.Utils.hideStr(str)
		},

		// 子组件触发查看日志
		handleViewLog(row) {
			console.log('父组件收到查看日志事件:', row)
			this.loadLogContent(row)
		},

		// 加载日志内容
		loadLogContent(row) {
			this.viewLogLoading = true
			this.$store
				.dispatch(STORE_CONST.LOG.VIEW_LOG, {
					params: {
						code: row.code,
						way: row.way,
						connection_id: row.connection_id,
						show: 1,
					},
				})
				.then((res) => {
					console.log('日志 API 返回:', res)
					this.viewLogLoading = false

					const cleanContent = Utility.Utils.filterAnsiEscapeCodes(res || '')
					this.logContent = cleanContent || '暂无日志内容'
					this.viewLogShow = true
					console.log('弹窗应该显示了, viewLogShow:', this.viewLogShow)
				})
				.catch((err) => {
					console.error('日志加载失败:', err)
					this.viewLogLoading = false
					this.$message.error('日志内容加载失败')
				})
		},

		// 关闭日志查看弹窗
		closeViewLogDialog() {
			this.viewLogShow = false
			this.logContent = ''
		},
	},
	watch: {
		$route(to, from) {
			this.setSearchData()
			this.getProjectResource(1)
		},
	},
	components: {
		WorkgroupOnlineConnection,
		WorkgroupConnectLogs,
		LinuxConfig,
		ManageCode,
		WorkGroupAssist,
		WorkgroupApply,
		CodemirrorEditor,
	},
}
</script>
<style lang="scss" rel="stylesheet/scss">
@import '../../assets/css/variable';

.work-group-detail {
	.btn-disabled-tooltip {
		color: #bfcbd9;
	}
	.m-b-none {
		margin-bottom: 10px;
	}
	.p-l-200 {
		padding-left: 200px;
		color: #bfcbd9;
		.el-form-item__content {
			font-size: 12px;
		}
	}
	.el-table__empty-block {
		position: initial;
	}
	.database-name-item {
		line-height: 20px;
		word-break: break-all;
	}
	.tip-point {
		display: inline-block;
		width: 7px;
		height: 7px;
		border-radius: 50%;
		margin-left: 3px;
		&.available {
			background-color: $available;
		}
		&.unavailable {
			background-color: $unavailable;
		}
		&:hover {
			cursor: pointer;
		}
	}
	a {
		color: #20a0ff;
		// color: #f60;
		cursor: pointer;
		&:hover {
			color: #4db3ff;
			// color: rgb(255, 130, 47);
		}
		&[disabled] {
			color: #bfcbd9;
			cursor: not-allowed;
		}
	}
	.temp-win {
		.text-center {
			color: red;
		}
		.el-row {
			height: 36px;
			line-height: 36px;
			.p-l-15 {
				padding-left: 15px;
			}
		}
	}
	.el-dialog--small {
		min-width: 710px;
	}
	.create-code-dialog,
	.modify-code-dialog {
		width: 560px;
		min-width: 0;
		max-width: calc(100% - 30px);
	}
	.code-input {
		width: 300px;
	}
	.psw-test-wrap {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		white-space: nowrap;
		.code-input-psw {
			width: 300px;
			flex: 0 0 auto;
		}
		.test-btn {
			margin-left: 10px;
			flex: 0 0 auto;
		}
		.test-status {
			margin-left: 10px;
			flex: 0 0 auto;
			font-size: 12px;
			&.test-status-success {
				color: $available;
				.el-icon-circle-check {
					margin-right: 4px;
				}
			}
		}
	}
	.code-input-time {
		width: 150px;
	}
	.create-code-time {
		display: inline-block;
		padding-left: 10px;
	}
	.p-l-note {
		padding-left: 53px;
		color: red;
	}
	.apply-safe {
		display: inline-block;
		color: $mainColor;
		border: 1px solid $mainColor;
		padding: 0 10px;
		height: 32px;
		line-height: 32px;
		&:hover {
			text-decoration: none;
			border-color: #4db3ff;
		}
	}
	.panel {
		height: 60px;
		line-height: 60px;
		background-color: #fff;
		border: 1px solid #ddd;
		border-bottom: 0;
		.panel-header {
			padding: 15px 15px;
			background: #fff;
			border-bottom: 0;
			.panel-search {
				/*position: relative;*/
				float: right;
				.search-input {
					width: 220px;
				}
				.dropdown {
					float: left;
					width: 120px;
					padding-right: 5px;
				}
				.search {
					float: left;
					width: 160px;
					margin-left: -1px;
					.btn {
						position: absolute;
						float: right;
						z-index: 1;
						right: 10px;
						top: 0;
						cursor: pointer;
					}
					.el-input > input {
						padding-right: 30px;
					}
				}
			}
		}
	}
	.el-tab-pane {
		.el-dropdown {
			color: $mainColor;
		}
	}
}
</style>



// WEBPACK FOOTER //
// workgroup-detail.vue?fbc30a0c